import React, { useContext, useEffect, useState } from "react";
import Popup from "../../../Helpers/Popup/Popup";
import { Segmented } from "antd";
import PopupTitle from "../../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../../Helpers/CloseBtn/Close";
import { popupcontext } from "../../../../context/Popupscontext";
import { getData } from "../../../../utils/IndexedDB";
import IROfflineForm from "./IROfflineForm";
import IROfflineInf from "./IROfflineInf";
import { Modal } from "react-bootstrap";

export default function IROfflinePopup() {
	const { offlinePopup, setOfflinePopup, currentIRId, setcurrentIRId } =
		useContext(popupcontext);
	const [formEditData, setFormEditData] = useState(null);
	const [segment, setSegment] = useState("Information");

	useEffect(() => {
		const initDB = async () => {
			try {
				if (currentIRId) {
					const irData = await getData("OfflineModeData", "IR", currentIRId);
					setFormEditData(irData);
				}
			} catch (error) {
				console.error("IndexedDB read error:", error);
			}
		};

		initDB();
	}, [currentIRId]);
	return (
		<Popup show={offlinePopup && currentIRId}>
			<Modal.Header className="modal-header flex-between">
				<Modal.Title id="contained-modal-title-vcenter">
					<PopupTitle headtitle={`${formEditData?.id}`} />
				</Modal.Title>
				<Close
					style="close-32 close"
					close={() => {
						setOfflinePopup(false);
						setFormEditData(null);
						setcurrentIRId(null);
					}}
					img="Close"
				/>
			</Modal.Header>
			<Segmented
				options={["Information", "Form"]}
				value={segment}
				onChange={(value) => setSegment(value)}
				block
			/>
			{formEditData && (
				<Modal.Body className="modal-body-scrollable">
					{segment === "Information" && (
						<IROfflineInf formEditData={formEditData} />
					)}

					{segment === "Form" && (
						<IROfflineForm formEditData={formEditData?.fields} />
					)}
				</Modal.Body>
			)}
		</Popup>
	);
}
